import { useEffect } from 'react'

export const useVersionCheck = () => {
  useEffect(() => {
    const checkVersion = () => {
      fetch('/version.json')
        .then(res => res.json())
        .then(data => {
          if (data.version !== window.localStorage.getItem('app_version')) {
            window.localStorage.setItem('app_version', data.version)
            window.location.reload(true)
          }
        })
    }

    checkVersion()
  }, [])
}
